export const bandwithGraphImages = ['mrtg_hourly'];
